import Reflux from 'reflux';
import EventDocData from 'shared/data/EventDoc';

let CuesheetCellLinkActions = Reflux.createActions({
  setActiveMode: {},
  setDocSearchTerm: { asyncResult: true },
  updateDocSearchTerm: {},
  loadMoreDocs: {},
  selectDocForInsert: {},
  saveSelectedDocLink: {},
});

CuesheetCellLinkActions.setDocSearchTerm.listenAndPromise(
  (teamId, eventId, term, page) => {
    return EventDocData.getByEventIdAndTerm(teamId, eventId, term, page).then(
      (results) => {
        results.term = term;
        return results;
      },
    );
  },
);

export default CuesheetCellLinkActions;
